module.exports = __webpack_public_path__ + "static/img/notebook_right.f736d6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notebook_right.png
// module id = Jlw1
// module chunks = 0